<div
  class="d-flex flex-column align-items-center h-100 w-100 justify-content-center px-4 py-4 modal-main"
>
  <div class="header mt-1 my-2 pb-3 w-100">
    <div class="d-flex justify-content-between">
      <img
        *ngIf="stepper !== 1"
        src="/assets/svg/ico-chevron-back-outline.svg"
        alt="back button"
        class="pointer-cursor"
        (click)="navigateBack()"
      />
      <h1 class="modal-title m-auto">{{ formInstance?.deviceName.value }}</h1>
      <img
        src="/assets/svg/ico-hamburger-close.svg"
        class="cross-button pointer-cursor"
        (click)="closeDialog()"
      />
    </div>
  </div>

  <div class="my-3">
    <p class="text-center heading-one">{{ 'SELECTE_A_DOOR_MODE' | translate }}</p>
    <p class="paragraph-text text-center px-2 mx-4">
      {{ 'SELECTE_A_PROPER_DOOR_MODE' | translate }}
    </p>
  </div>

  <div class="container lock-detail px-2 mb-208">
    <div class="group-container">
      <form [formGroup]="formGroup" novalidate>
        <ng-container *ngFor="let radionButton of radionButtons; let i = index">
          <div
            (click)="radioRef.click(); activate(radionButton)"
            class="checked-card"
            [class.active]="radionButton.active"
          >
            <img
              [src]="
                radionButton.active
                  ? 'assets/svg/ico-checkmark-circle-outline.svg'
                  : 'assets/svg/ico-circle.svg'
              "
              class="check-circle"
            />
            <div class="content-box">
              <input
                type="radio"
                class="d-none"
                [value]="radionButton.value"
                #radioRef
                formControlName="deviceMode"
              />
              <h3 class="title">{{ radionButton.label }}</h3>
            </div>
          </div>
        </ng-container>
      </form>
    </div>
  </div>
  <div class="row w-100 px-3 py-3">
    <div class="w-100">
      <button
        class="btn btn-danger update-btn px-3"
        [disabled]="
          !(
            this.formInstance?.deviceMode.value === 1 ||
            this.formInstance?.deviceMode.value === 2
          )
        "
        (click)="changeDeviceType()"
      >
        {{ 'UPDATE' | translate }}
      </button>
    </div>
  </div>
</div>
